import { useState } from 'react';
import { Link, IconButton, type IconButtonProps } from '@trg/tlw-ui-component';
import { useHeaderData } from '../hooks';
import { selectSmartBanner } from '../api';

export function SmartBanner() {
  const isExist = document.cookie.indexOf('m_s_bn=') === -1;
  const data = useHeaderData();
  const smartBanner = selectSmartBanner(data);

  const [visible, setVisible] = useState(isExist);

  if (!smartBanner || !visible) return null;

  // 設定 smartBanner 廣告 cookies
  const setSmartBannerCookies = () => {
    const exp = new Date();
    exp.setTime(exp.getTime() + 864e5);
    const expDate = `expires=${exp.toUTCString()}`;
    document.cookie = `m_s_bn=1; ${expDate}; path=/;`;
  };

  const close: IconButtonProps['onClick'] = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setVisible(false);
    setSmartBannerCookies();
  };

  return (
    <Link
      id="TopSmartBanner"
      className="tlw-px-3 tlw-py-1.5 tlw-flex tlw-justify-between tlw-items-center tlw-bg-gray-100 lg:tlw-hidden"
      href={smartBanner.link}
      target={smartBanner.linkTarget}
    >
      <div className="tlw-flex tlw-items-center tlw-gap-2">
        <div className="tlw-size-11 tlw-p-[5px] tlw-rounded-lg tlw-shadow-[0px_2px_4px_0px_#2E2E2E1A]">
          <img
            className="tlw-size-full tlw-object-cover"
            src={smartBanner.mobileImageMediasUrl}
            alt="tlw app"
          />
        </div>

        <div className="tlw-txt-zh-head-8 tlw-text-txt-black">
          <p className="-tlw-mb-2">{smartBanner.mainHeading}</p>
          <p className="-tlw-mt-2">{smartBanner.subHeading}</p>
        </div>
      </div>

      <IconButton icon="X" iconSize={24} square onClick={close} />
    </Link>
  );
}
